import React, { useState } from "react";

const PreviewModal = ({ isOpen, onClose, data, onConfirm }) => {
  if (!isOpen) return null;

  const {
    personalInfo = {},
    educationDetails = {},
    address = {},
    gaurdianInfo = {},
    customFields = {},
    imagePreview = null,
    courseName = "",
    genderName = "",
    categoryName = "",
    subCategoryName = "",
    coachingName = "",
    className = "",
    mediumName = "",
    selectedIncomeName = "",
    selectedFatherIncomeName = "",
    localCityName = "",
    permCityName = "",
    previousCoachingName = "",
    domicileName = "",
  } = data;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
      padding: "20px",
    }}>
      <div style={{
        backgroundColor: "white",
        borderRadius: "12px",
        width: "90%",
        maxWidth: "900px",
        maxHeight: "85vh",
        marginTop: "40px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 20px 25px rgba(0, 0, 0, 0.15)",
      }}>
        {/* Header */}
        <div style={{
          padding: "30px",
          borderBottom: "1px solid #e5e7eb",
          backgroundColor: "#ffffff",
        }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "20px",
          }}>
            <div>
              <h1 style={{
                margin: "0 0 8px 0",
                fontSize: "28px",
                fontWeight: "700",
                color: "#6A6A6A",
              }}>
                Registration Summary
              </h1>
              <p style={{
                margin: 0,
                fontSize: "14px",
                color: "#6b7280",
              }}>
                Please verify the information below before confirming your application.
              </p>
            </div>
            <div style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}>
              <button
                onClick={onClose}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px 8px",
                  fontSize: "24px",
                  color: "#9ca3af",
                  fontWeight: "bold",
                }}
              >
                ×
              </button>
            </div>
          </div>
        </div>

        {/* Content */}
        <div style={{
          padding: "30px",
          overflow: "auto",
          flex: 1,
        }}>
          {/* Student Header Card */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "40px",
            paddingBottom: "20px",
            borderBottom: "1px solid #e5e7eb",
          }}>
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Student"
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  border: "2px solid #e5e7eb",
                }}
              />
            )}
            <div style={{ flex: 1 }}>
              <h2 style={{
                margin: "0 0 4px 0",
                fontSize: "24px",
                fontWeight: "700",
                color: "#6A6A6A",
              }}>
                {personalInfo.student_first_name} {personalInfo.student_last_name}
              </h2>
              <p style={{
                margin: "0 0 16px 0",
                fontSize: "14px",
                color: "#6b7280",
              }}>
                Enquiry Number: {personalInfo.enquiry_id || "N/A"}
              </p>
              <div style={{
                display: "flex",
                gap: "24px",
              }}>
                <div>
                  <div style={{
                    fontSize: "12px",
                    color: "#9ca3af",
                    fontWeight: "600",
                    marginBottom: "4px",
                  }}>
                    Roll Number
                  </div>
                  <div style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}>
                    {personalInfo.roll_number || "N/A"}
                  </div>
                </div>
                <div>
                  <div style={{
                    fontSize: "12px",
                    color: "#9ca3af",
                    fontWeight: "600",
                    marginBottom: "4px",
                  }}>
                    CLASS TYPE
                  </div>
                  <div style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}>
                    {personalInfo.class_type_id === 1 ? "Online" : "Classroom"}
                  </div>
                </div>
                <div>
                  <div style={{
                    fontSize: "12px",
                    color: "#9ca3af",
                    fontWeight: "600",
                    marginBottom: "4px",
                  }}>
                    COURSE
                  </div>
                  <div style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}>
                    {courseName || "N/A"}
                  </div>
                </div>
              </div>
            </div>
            <div style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "flex-end",
            }}>
            </div>
          </div>
          <Section
            title="Personal Details"
            icon="👤"
            fields={[
              { label: "Full Legal Name", value: `${personalInfo.student_first_name || ""} ${personalInfo.student_middle_name || ""} ${personalInfo.student_last_name || ""}`.trim() },
              { label: "Date of Birth", value: personalInfo.date_of_birth},
              { label: "Gender", value: genderName },
              { label: "Aadhar Number", value: personalInfo.aadhaar_no },
              { label: "Category", value: categoryName },
              { label: "Sub Category", value: subCategoryName },
              { label: "Domicile State", value: domicileName },
              { label: "Phone Number", value: personalInfo.student_mob_no },
              { label: "Email Address", value: personalInfo.email_id },
              { label: "Emergency Contact", value: personalInfo.emrgency_contact_mob_no },
              { label: "Previous Coaching", value: coachingName },
            ]}
          />
          {Object.keys(address).length > 0 && (
            <Section
              title="Address Details"
              icon="📍"
              fields={[
                { label: "Local Address Line 1", value: address.loc_add1 },
                { label: "Local Address Line 2", value: address.loc_add2 },
                { label: "Local City", value: data.localCityName},
                { label: "Local Pin Code", value: address.loc_pincode },
                { label: "Permanent Address Line 1", value: address.perm_add1 },
                { label: "Permanent Address Line 2", value: address.perm_add2 },
                { label: "Permanent City", value: data.permCityName },
                { label: "Permanent Pin Code", value: address.perm_pincode },
              ]}
            />
          )}
          {Object.keys(educationDetails).length > 0 && (
            <Section
              title="Academic Information"
              icon="🎓"
              fields={[
                { label: "Previous Institution", value: data.previousCoachingName },
                { label: "Last Class", value: className },
                { label: "Medium of Education", value: mediumName },
              ]}
            />
          )}
          {Object.keys(gaurdianInfo).some((key) => gaurdianInfo[key]) && (
            <Section
              title="Guardian Information"
              icon="👥"
              fields={[
                { label: "Father's Name", value: gaurdianInfo.fathers_name },
                { label: "Father's Occupation", value: gaurdianInfo.fathers_occupation },
                { label: "Father's Designation", value: gaurdianInfo.fathers_designation },
                { label: "Father's Annual Income", value: selectedFatherIncomeName },
                { label: "Father's Email", value: gaurdianInfo.fathers_email_id },
                { label: "Father's Mobile", value: gaurdianInfo.fathers_mob_no },
                { label: "Mother's Name", value: gaurdianInfo.mothers_name },
                { label: "Mother's Occupation", value: gaurdianInfo.mothers_occupation },
                { label: "Mother's Designation", value: gaurdianInfo.mothers_designation },
                { label: "Mother's Annual Income", value: selectedIncomeName },
                { label: "Mother's Email", value: gaurdianInfo.mothers_email_id },
                { label: "Mother's Mobile", value: gaurdianInfo.mothers_mob_no },
                { label: "Guardian Name", value: gaurdianInfo.guardian_name },
                { label: "Guardian Mobile", value: gaurdianInfo.guardian_mob_no },
                { label: "Guardian Relation", value: gaurdianInfo.guardian_relation },
                { label: "Comments", value: gaurdianInfo.comments_ },
              ]}
            />
          )}
          {customFields && Object.values(customFields).some((val) => val !== "") && (
            <Section
              title="Custom Fields"
              icon="📋"
              fields={Object.entries(customFields)
                .filter(([_, value]) => value)
                .map(([key, value]) => ({
                  label: key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
                  value: value
                }))}
            />
          )}
        </div>
        <div style={{
          padding: "20px 30px",
          borderTop: "1px solid #e5e7eb",
          backgroundColor: "#f9fafb",
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
        }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 24px",
              borderRadius: "6px",
              border: "1px solid #d1d5db",
              backgroundColor: "white",
              fontSize: "16px",
              fontWeight: "500",
              color: "#424342",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#f3f4f6";
              e.target.style.borderColor = "#9ca3af";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.borderColor = "#d1d5db";
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "10px 24px",
              borderRadius: "6px",
              border: "none",
              color: "white",
              fontSize: "16px",
              fontWeight: "500",
              color: "#424342",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.2s",
              border: "1px solid #d1d5db",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#fa4741";
              e.target.style.borderColor = "#9ca3af";
              e.target.style.color = "white";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.borderColor = "#d1d5db";
              e.target.style.color = "#374151";
            }}
          >
            ✓ Confirm & Save
          </button>
        </div>
      </div>
    </div>
  );
};

const Section = ({ title, icon, fields }) => {
  const visibleFields = fields.filter(f => f.value);

  if (visibleFields.length === 0) return null;

  return (
    <div style={{ marginBottom: "32px" }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "20px",
        paddingBottom: "12px",
        borderBottom: "2px solid #e5e7eb",
      }}>
        <span style={{ fontSize: "20px" }}>{icon}</span>
        <h3 style={{
          margin: 0,
          fontSize: "16px",
          fontWeight: "700",
          color: "#6A6A6A",
        }}>
          {title}
        </h3>
      </div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "32px",
      }}>
        {visibleFields.map((field, idx) => (
          <div key={idx} style={{ gridColumn: field.col === 2 ? "1 / -1" : "auto" }}>
            <div style={{
              fontSize: "12px",
              color: "#9ca3af",
              fontWeight: "600",
              marginBottom: "6px",
              letterSpacing: "0.5px",
            }}>
              {field.label}
            </div>
            <div style={{
              fontSize: "14px",
              color: "#6A6A6A",
              fontWeight: "500",
            }}>
              {field.value || "N/A"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreviewModal;















































// import React, { useState, useEffect, useRef } from "react";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import "../registrationfrom.css";

// // Preview Modal Component
// const PreviewModel = ({ isOpen, onClose, data, onConfirm }) => {
//   if (!isOpen) return null;

//   const {
//     personalInfo,
//     educationDetails,
//     address,
//     gaurdianInfo,
//     customFields,
//     imagePreview
//   } = data;

//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0, 0, 0, 0.5)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 1000,
//         padding: "20px",
//       }}
//     >
//       <div
//         style={{
//           backgroundColor: "white",
//           borderRadius: "8px",
//           width: "90%",
//           maxWidth: "1200px",
//           maxHeight: "90vh",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             padding: "20px",
//             borderBottom: "2px solid #e5e7eb",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             backgroundColor: "#f9fafb",
//           }}
//         >
//           <h2
//             style={{
//               margin: 0,
//               fontSize: "24px",
//               fontWeight: "600",
//               color: "#6A6A6A",
//             }}
//           >
//             Preview Student Registration
//           </h2>
//           <button
//             onClick={onClose}
//             style={{
//               background: "none",
//               border: "none",
//               cursor: "pointer",
//               padding: "5px",
//             }}
//           >
//             <span
//               style={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 background: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               X
//             </span>
//           </button>
//         </div>

//         {/* Content */}
//         <div
//           style={{
//             padding: "20px",
//             overflow: "auto",
//             flex: 1,
//           }}
//         >
//           {/* Personal Information */}
//           <div style={{ marginBottom: "30px" }}>
//             <h3
//               style={{
//                 fontSize: "18px",
//                 fontWeight: "600",
//                 marginBottom: "15px",
//                 color: "#6A6A6A",
//                 borderBottom: "2px solid #D6D6D6",
//                 paddingBottom: "8px",
//               }}
//             >
//               Personal Information
//             </h3>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//                 gap: "15px",
//               }}
//             >
//               {imagePreview && (
//                 <div style={{ gridColumn: "1 / -1" }}>
//                   <img
//                     src={imagePreview}
//                     alt="Student"
//                     style={{
//                       width: "150px",
//                       height: "150px",
//                       objectFit: "cover",
//                       borderRadius: "8px",
//                       border: "2px solid #e5e7eb",
//                     }}
//                   />
//                 </div>
//               )}
//               <InfoItem label="Roll Number" value={personalInfo.roll_number} />
//               <InfoItem
//                 label="Class Type"
//                 value={
//                   personalInfo.class_type_id === 1 ? "Online" : "Classroom"
//                 }
//               />
//               <InfoItem
//                 label="First Name"
//                 value={personalInfo.student_first_name}
//               />
//               <InfoItem
//                 label="Middle Name"
//                 value={personalInfo.student_middle_name}
//               />
//               <InfoItem
//                 label="Last Name"
//                 value={personalInfo.student_last_name}
//               />
//               <InfoItem
//                 label="Date of Birth"
//                 value={personalInfo.date_of_birth}
//               />
//               <InfoItem label="Gender" value={personalInfo.gender_id} />
//               <InfoItem label="Aadhar Number" value={personalInfo.aadhaar_no} />
//               <InfoItem label="Category" value={personalInfo.category_id} />
//               <InfoItem
//                 label="Sub Category"
//                 value={personalInfo.sub_category_id}
//               />
//               <InfoItem
//                 label="Domicile State"
//                 value={personalInfo.domicile_city_id}
//               />
//               <InfoItem
//                 label="Mobile Number"
//                 value={personalInfo.student_mob_no}
//               />
//               <InfoItem label="Email ID" value={personalInfo.email_id} />
//               <InfoItem
//                 label="Emergency Contact"
//                 value={personalInfo.emrgency_contact_mob_no}
//               />
//               <InfoItem label="Course" value={personalInfo.course_id} />
//               <InfoItem
//                 label="Previous coaching"
//                 value={personalInfo.last_coaching_id}
//               />
//             </div>
//           </div>

//           {/* Education Details */}
//           {Object.keys(educationDetails).length > 0 && (
//             <div style={{ marginBottom: "30px" }}>
//               <h3
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   marginBottom: "15px",
//                   color: "#6A6A6A",
//                   borderBottom: "2px solid #D6D6D6",
//                   paddingBottom: "8px",
//                 }}
//               >
//                 Education Details
//               </h3>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//                   gap: "15px",
//                 }}
//               >
//                 <InfoItem
//                   label="Last School"
//                   value={educationDetails.last_school_id}
//                 />
//                 <InfoItem
//                   label="Current Class"
//                   value={educationDetails.current_class_id}
//                 />
//                 <InfoItem
//                   label="Education Medium"
//                   value={educationDetails.education_medium_id}
//                 />
                
//               </div>
//             </div>
//           )}

//           {/* Address Information */}
//           {Object.keys(address).length > 0 && (
//             <div style={{ marginBottom: "30px" }}>
//               <h3
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   marginBottom: "15px",
//                   color: "#6A6A6A",
//                   borderBottom: "2px solid #D6D6D6",
//                   paddingBottom: "8px",
//                 }}
//               >
//                 Address Information
//               </h3>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "20px",
//                 }}
//               >
//                 <div>
//                   <h4
//                     style={{
//                       fontSize: "16px",
//                       fontWeight: "500",
//                       marginBottom: "10px",
//                       color: "#4b5563",
//                     }}
//                   >
//                     Local Address
//                   </h4>
//                   <InfoItem label="Address Line 1" value={address.loc_add1} />
//                   <InfoItem label="Address Line 2" value={address.loc_add2} />
//                   <InfoItem label="City" value={address.loc_city_id} />
//                   <InfoItem label="Pin Code" value={address.loc_pincode} />
//                 </div>
//                 <div>
//                   <h4
//                     style={{
//                       fontSize: "16px",
//                       fontWeight: "500",
//                       marginBottom: "10px",
//                       color: "#4b5563",
//                     }}
//                   >
//                     Permanent Address
//                   </h4>
//                   <InfoItem label="Address Line 1" value={address.perm_add1} />
//                   <InfoItem label="Address Line 2" value={address.perm_add2} />
//                   <InfoItem label="City" value={address.perm_city_id} />
//                   <InfoItem label="Pin Code" value={address.perm_pincode} />
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Guardian Information */}
//           {Object.keys(gaurdianInfo).some((key) => gaurdianInfo[key]) && (
//             <div style={{ marginBottom: "30px" }}>
//               <h3
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   marginBottom: "15px",
//                   color: "#6A6A6A",
//                   borderBottom: "2px solid #D6D6D6",
//                   paddingBottom: "8px",
//                 }}
//               >
//                 Guardian Information
//               </h3>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: "20px",
//                 }}
//               >
//                 <div>
//                   <h4
//                     style={{
//                       fontSize: "16px",
//                       fontWeight: "500",
//                       marginBottom: "10px",
//                       color: "#4b5563",
//                     }}
//                   >
//                     Father's Details
//                   </h4>
//                   <InfoItem label="Name" value={gaurdianInfo.fathers_name} />
//                   <InfoItem
//                     label="Occupation"
//                     value={gaurdianInfo.fathers_occupation}
//                   />
//                   <InfoItem
//                     label="Designation"
//                     value={gaurdianInfo.fathers_designation}
//                   />
//                   <InfoItem
//                     label="Annual Income"
//                     value={gaurdianInfo.fathers_annual_income}
//                   />
//                   <InfoItem
//                     label="Email"
//                     value={gaurdianInfo.fathers_email_id}
//                   />
//                   <InfoItem
//                     label="Mobile"
//                     value={gaurdianInfo.fathers_mob_no}
//                   />
//                 </div>
//                 <div>
//                   <h4
//                     style={{
//                       fontSize: "16px",
//                       fontWeight: "500",
//                       marginBottom: "10px",
//                       color: "#4b5563",
//                     }}
//                   >
//                     Mother's Details
//                   </h4>
//                   <InfoItem label="Name" value={gaurdianInfo.mothers_name} />
//                   <InfoItem
//                     label="Occupation"
//                     value={gaurdianInfo.mothers_occupation}
//                   />
//                   <InfoItem
//                     label="Designation"
//                     value={gaurdianInfo.mothers_designation}
//                   />
//                   <InfoItem
//                     label="Annual Income"
//                     value={gaurdianInfo.mothers_annual_income}
//                   />
//                   <InfoItem
//                     label="Email"
//                     value={gaurdianInfo.mothers_email_id}
//                   />
//                   <InfoItem
//                     label="Mobile"
//                     value={gaurdianInfo.mothers_mob_no}
//                   />
//                 </div>
//               </div>
//               {gaurdianInfo.guardian_name && (
//                 <div style={{ marginTop: "15px" }}>
//                   <h4
//                     style={{
//                       fontSize: "16px",
//                       fontWeight: "500",
//                       marginBottom: "10px",
//                       color: "#4b5563",
//                     }}
//                   >
//                     Guardian Details
//                   </h4>
//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns:
//                         "repeat(auto-fit, minmax(250px, 1fr))",
//                       gap: "15px",
//                     }}
//                   >
//                     <InfoItem label="Name" value={gaurdianInfo.guardian_name} />
//                     <InfoItem
//                       label="Mobile"
//                       value={gaurdianInfo.guardian_mob_no}
//                     />
//                     <InfoItem
//                       label="Relation"
//                       value={gaurdianInfo.guardian_relation}
//                     />
//                   </div>
//                 </div>
//               )}
//               {gaurdianInfo.comments_ && (
//                 <div style={{ marginTop: "15px" }}>
//                   <InfoItem label="Comments" value={gaurdianInfo.comments_} />
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Custom Fields */}
//           {Object.values(customFields).some((val) => val !== "") && (
//             <div style={{ marginBottom: "30px" }}>
//               <h3
//                 style={{
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   marginBottom: "15px",
//                   color: "#6A6A6A",
//                   borderBottom: "2px solid #D6D6D6",
//                   paddingBottom: "8px",
//                 }}
//               >
//                 Custom Fields
//               </h3>
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//                   gap: "15px",
//                 }}
//               >
//                 {Object.entries(customFields).map(
//                   ([key, value]) =>
//                     value && (
//                       <InfoItem
//                         key={key}
//                         label={key
//                           .replace(/_/g, " ")
//                           .replace(/\b\w/g, (l) => l.toUpperCase())}
//                         value={value}
//                       />
//                     )
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Footer */}
//         <div
//           style={{
//             padding: "20px",
//             borderTop: "2px solid #e5e7eb",
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: "10px",
//             backgroundColor: "#f9fafb",
//           }}
//         >
//           <button
//             onClick={onClose}
//             style={{
//               padding: "10px 24px",
//               borderRadius: "6px",
//               border: "1px solid #d1d5db",
//               backgroundColor: "white",
//               color: "#374151",
//               fontSize: "14px",
//               fontWeight: "500",
//               cursor: "pointer",
//             }}
//             onMouseOver={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
//             onMouseOut={(e) => (e.target.style.backgroundColor = "white")}
//           >
//             CANCEL
//           </button>
//           <button
//             onClick={onConfirm}
//             className="preview-confirm-btn-stud-reg"
//           >
//             CONFIRM & SAVE
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PreviewModel;


// // Info Item Component
// const InfoItem = ({ label, value }) => {
//   if (!value) return null;
  
//   return (
//     <div style={{ marginBottom: "10px" }}>
//       <div style={{
//         fontSize: "14px",
//         color: "#6b7280",
//         fontWeight: "500",
//         marginBottom: "4px",
//         // textTransform: "uppercase",
//         letterSpacing: "0.5px"
//       }}>
//         {label}
//       </div>
//       <div style={{
//         fontSize: "14px",
//         color: "#6A6A6A",
//         fontWeight: "400",
//         padding: "8px",
//         backgroundColor: "#f9fafb",
//         borderRadius: "4px",
//         border: "1px solid #e5e7eb"
//       }}>
//         {value}
//       </div>
//     </div>
//   );
// };
